{
  "goalCard": {
    "title": "Make your name in Kabukichō",
    "lines": [
      "Take jobs at fixer kiosks (K on the map) for cash and street cred.",
      "Spend cash at Hachi's and Doc Neko's, and points in Skills, to upgrade your runner.",
      "More cred unlocks bigger jobs, and the Boss Hunts at 50, 75 and 100."
    ]
  },
  "goals": [
    { "id": "first-job", "when": "noCred", "text": "Take a job at a fixer kiosk (M for map)", "point": "kiosk" },
    { "id": "spend-points", "when": "points", "text": "Spend your points in Skills (Tab)" },
    { "id": "boss-hunt", "when": "bossHunt", "minCred": 50, "text": "Take a Boss Hunt at a fixer kiosk", "point": "kiosk" },
    { "id": "next-unlock", "when": "nextUnlock", "text": "Reach {n} cred to unlock {name}" },
    { "id": "keep-going", "when": "always", "text": "Keep taking jobs at fixer kiosks for cash and cred", "point": "kiosk" }
  ]
}
